import { ReactComponent as LaborIcon } from './labor.svg';

export default LaborIcon;
